import { createSlotRecipe } from './runtime.js';

const chatSystemMessageConfig = {"name":"chatSystemMessage","slots":["root","content"],"defaultVariants":{"appearance":"pill"},"variantMap":{"appearance":["pill","plain"]}}

export const chatSystemMessage = /* @__PURE__ */ createSlotRecipe(chatSystemMessageConfig)